import React, { useState } from "react";
import { TextField, Box, Grid } from "@mui/material";

const CustomSearchBuyer = ({ onSearch, t, disableSearchOnType = false }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    if (!disableSearchOnType) onSearch(event.target.value);
  };
  const handleSearchIconClick = () => {
    onSearch(searchQuery);
  };
  return (
    <Box sx={{ padding: "0" }}>
      <Grid container sx={{ marginTop: "0px" }} spacing={1}>
        <Grid item xs={9.5}>
          <TextField
            id="search"
            label={t("Enter Code or Link")}
            variant="outlined"
            sx={{ marginTop: "0px" }}
            fullWidth
            value={searchQuery}
            onChange={handleSearchChange}
            size="big"
          />
        </Grid>
        <Grid item xs={2}>
          <Box onClick={handleSearchIconClick} sx={{ padding: "0px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#4CAF50",
                width: "65px",
                height: "54px",
                borderRadius: "4px",
                border: "1px solid #A5A5A5",
                color: "#FFFFFF",
              }}
            >
              <p>Go</p>
            </div>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomSearchBuyer;
